<template>
  <el-popover :popperClass="$style.container" :popper-options="popperOptions" :open-delay="300" placement="right" width="790" trigger="click" v-model="modelVisible">
    <div>
      <div class="title flex items-center justify-between" :class="$style.title">
        <span class="text-[#000] text-[15px] font-bold">线路行程</span>
        <span class="ficon ficon-guanbi cursor-pointer select-none" @click="close"></span>
      </div>
      <el-table :class="$style.table" stripe :data="all_voyage"  height="600" style="width: 100%;">
        <el-table-column align="center" type="expand" width="50">
          <template slot-scope="scope">
            <div class="pl-[160px]">
              <el-table :class="$style.table__inner" stripe :data="scope.row.product_tours" style="width: 100%">
                <el-table-column prop="date" label="日期" width="180">
                </el-table-column>
                <el-table-column prop="name" label="港口">
                  <template slot-scope="scopeInner">
                    <div class="flex">
                      <span class="ficon ficon-xingzhuangjiehe1 mr-[10px]"></span>
                      <ul>
                        <li v-for="(port_data, portDataIndex) in scopeInner.row.port_data" :key="portDataIndex">
                          <el-image v-if="port_data.flag" class="mr-[10px]" style="width: 18px" :src="port_data.flag"></el-image>
                          <!-- <span>{{port_data.city_name }}</span> -->
                          <span>{{port_data.port }}</span>
                        </li>
                      </ul>
                      <span class="ml-[10px]">
                        {{ scopeInner.$index == 0 ? '出发' : ''  }}
                        {{ scopeInner.$index == scope.row.product_tours.length - 1 && scope.row.product_tours.length > 1 ? '结束' : ''  }}
                      </span>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="日期" prop="date" width="100">
        </el-table-column>
        <el-table-column align="center" label="产品名称" prop="name">
        </el-table-column>
        <el-table-column align="center" label="港口" prop="port" #default="{row}">
          <div class="flex items-center justify-center">
            <el-image v-if="row.flag" class=" mr-[10px]" style="width: 18px" :src="row.flag"></el-image>
            <span class="text-xs">{{ row.port }}</span>
          </div>
        </el-table-column>
        <el-table-column align="center" label="价格" prop="price" #default="{row}">
          ￥{{ row.price }}
        </el-table-column>
      </el-table>
    </div>

    <div slot="reference">
      <slot></slot>
    </div>
  </el-popover>

</template>
<script>
import { useVModel } from "@vueuse/core";
export default {
	name: "popover-route-detail",
	props: {
		visible: Boolean,
		all_voyage: {
			typeof: Array,
			// TODO 测试数据
			default: () => []
		}
	},
	setup(props, { emit }) {
		const modelVisible = useVModel(props, "visible", emit);
		const popperOptions = {
			positionFixed: true
			// boundariesElement: '.j_main'
		};
		return {
			popperOptions,
			modelVisible
		};
	},
	// data() {
	// 	return {
	// 		visible: false
	// 	};
	// },
	mounted() {},
	methods: {
		close() {
			this.modelVisible = false;
		}
	}
};
</script>
<style lang="scss" module>
.title {
  padding: 5px 0 12px;
}
.container {
  max-height: 100%;
  overflow-y: auto;
}
.table :global(.el-table__header-wrapper) {
  border-radius: 2px !important;
}
.table :global(.el-table__header-wrapper) * {
  color: #fff !important;
  background-color: #f25b3b !important;
}
.table :global(.el-table__row.expanded), .table :global(.el-table__row.expanded *) {
  background-color: #fff5f5 !important;
  color: #f25b3b !important;
}
.table :global(.el-table__row.expanded td:nth-child(3)) {
  font-weight: 500 !important;
}
.table__inner :global(.el-table__header-wrapper) {
  border-radius: 0 !important;
}
.table__inner :global(.el-table__header-wrapper) * {
  color: #f25b3b !important;
  background-color: #fff5f5 !important;
  border: none !important;
}
.table__inner :global(.el-table__row--striped), .table__inner :global(.el-table__row--striped *) {
  background-color: #fff5f5 !important;
}
</style>